<template>
  <v-dialog v-model="dialog" persistent max-width="700">
    <v-card>
      <v-card-title class="headline">
        <v-icon class="mr-2" color="error">mdi-alert</v-icon>
        Start
        <span class="error--text advanced-warn" v-if="isAdvanced">
          advanced
        </span>
        re-match process?
      </v-card-title>
      <v-card-text>
        <v-stepper v-model="stepper" class="elevation-0" vertical>
          <v-stepper-step editable :complete="stepper > 1" step="1">
            Choose Configurations
            <small>Provide inventory matcher configuration parameters</small>
          </v-stepper-step>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-form ref="form" v-model="valid" lazy-validation>
                <TaskParametersForm
                  is-re-match
                  ref="taskParametersForm"
                  :context="previousParams.context"
                />
              </v-form>
            </v-stepper-content>
            <v-stepper-step :complete="stepper > 2" step="2">
              Agreement
            </v-stepper-step>
            <v-stepper-content step="2">
              <span class="error--text text-h6">
                By this action you will start re-match for the whole document.
                Are you sure?
              </span>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="error" text @click="close">Disagree</v-btn>
        <v-btn color="primary" text @click="agree">Agree</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import TaskParametersForm from '../../tasks/TaskParametersForm';

export default {
  data() {
    return {
      valid: true,
      dialog: false,
      stepper: 1,
      previousParams: {},
      isAdvanced: false
    };
  },
  components: {
    TaskParametersForm
  },
  methods: {
    open(previousParams = {}, isAdvanced = false) {
      this.previousParams = previousParams;
      this.stepper = 1;
      this.valid = true;
      this.dialog = true;
      this.isAdvanced = isAdvanced;
    },
    close() {
      this.dialog = false;
    },
    agree() {
      if (!this.$refs.form.validate()) return;

      if (this.stepper < 2) {
        this.stepper++;
        return;
      } else {
        const context = JSON.stringify(this.$refs.taskParametersForm.getData());
        this.$emit('onAgree', context, this.isAdvanced);
        this.close();
      }
    }
  }
};
</script>

<style lang="scss">
.advanced-warn {
  margin: 0 8px;
}
</style>
